import { useApi } from '@/api';
import { Flex, KpiCard, KpiSkeleton } from '@blockanalitica/ui';
import AirdropDistributionSection from './AirdropDistributionSection';

type DataResponse = {
  aave_total_farmed: string;
  v1_campaign_total_farmed: string;
  v2_campaign_total_farmed: string;
  total_farmed: string;
  sparklend_total_farmed: string;
  tokens_per_second: string;
};

export default function PreFarmingKpi() {
  const [data, error] = useApi<DataResponse>({
    url: '/sparkstar/spk/pre-farming/'
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap="m">
      <KpiCard
        data={{
          total_farmed: data['total_farmed']
        }}
        title={'SPK Pre-Farming Airdrop'}
        field="total_farmed"
        options={{
          currency: {
            name: 'SPK',
            address: '0x00000000000000000000000000000000000spark'
          },
          endlessPerSecond: Number(data['tokens_per_second']),
          variants: {
            kpiCardValue: 'mainValue'
          }
        }}
      />
      <AirdropDistributionSection data={data} />
    </Flex>
  );
}
